import React, { Component } from "react";
import { Container } from "semantic-ui-react";
import { Page, PageConsumer, PageProvider } from "@devgateway/wp-react-lib";
import { injectIntl } from "react-intl";
class Footer extends Component {
  componentDidMount() {}
  render() {
    const {
      children,
      fixed,
      location,
      intl: {
        locale
      }
    } = this.props;
    return /*#__PURE__*/React.createElement(Container, {
      fluid: true,
      className: "viz footer"
    }, /*#__PURE__*/React.createElement(PageProvider, {
      locale: locale,
      slug: "footer",
      store: "footer"
    }, /*#__PURE__*/React.createElement(PageConsumer, null, /*#__PURE__*/React.createElement(Page, null))));
  }
}
export default injectIntl(Footer);